import { usePersistState } from '~/composables/usePersistState'

export const useCurrentTargetDate = () => {
  const currentTargetDate = usePersistState<string | null>('currentTargetDate', null)
  return {
    currentTargetDate,
  }
}
